module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 48
// module chunks = 0